import React from "react";
var __jsx = React.createElement;
import Banner from "./components/Banner/Banner";
import BuyItWeDeliverItSingle from "./components/BuyItWeDeliverItSingle/BuyItWeDeliverItSingle";
import MakeCars from "./components/MakeCars/MakeCars";
import List from "./components/List/List";
import CarsFinance from "./components/CarsFinance/CarsFinance";
import stl from "./SingleCityComponent.module.css";
import LatestOffer from "../Cities/components/LatestOffer/LatestOffer";
import { useTranslation } from "@i18n";
var SingleCityComponent = function SingleCityComponent(_ref) {
  var cityDetails = _ref.cityDetails,
    cityName = _ref.cityName;
  var _useTranslation = useTranslation(["web_city"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Banner, {
    cityName: cityName
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.SC_container
  }, (cityDetails === null || cityDetails === void 0 ? void 0 : cityDetails.posts) && /*#__PURE__*/React.createElement(LatestOffer, {
    posts: cityDetails === null || cityDetails === void 0 ? void 0 : cityDetails.posts
  }), /*#__PURE__*/React.createElement(BuyItWeDeliverItSingle, {
    cityName: cityName
  }), (cityDetails === null || cityDetails === void 0 ? void 0 : cityDetails.makes) && /*#__PURE__*/React.createElement(MakeCars, {
    makes: cityDetails === null || cityDetails === void 0 ? void 0 : cityDetails.makes,
    cityName: cityName
  }), /*#__PURE__*/React.createElement(CarsFinance, {
    cityName: cityName
  }), (cityDetails === null || cityDetails === void 0 ? void 0 : cityDetails.cities) && /*#__PURE__*/React.createElement(List, {
    title: t("deliver_car_saudi_provinces", {
      ns: "web_city"
    }),
    list: Object.values(cityDetails === null || cityDetails === void 0 ? void 0 : cityDetails.cities).filter(function (city) {
      return city.name !== cityName;
    }).slice(0, 8),
    name: cityName,
    buttonText: t("cities", {
      ns: "web_city"
    }),
    buttonUrl: "/city"
  }))));
};
export default SingleCityComponent;